<aumico-users-reset-password-page
    (resendVerificationMail)="onResendVerificationMail($event)"
    (resetPasswordSuccess)="onSetOrResetPasswordSuccess()"
    (passwordSet)="onPasswordSet($event)"
></aumico-users-reset-password-page>

<app-component-random-questions-with-action-button
    [question]="loginQuestionTextKey"
    [actionButton]="{ title: loginQuestionButtonTextKey, action: questionButtonClickedAction }"
>
</app-component-random-questions-with-action-button>
